module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsValentine.cd10a4b.webp";